module.exports = __webpack_public_path__ + "static/media/about img4.6199d115.webp";